import { useEffect } from 'react'
import renderImage from '../../../../source/importImg'
import SliderBox from '../../../ReusableComponents/SliderBox/SliderBox'
import servoPopupStyle from './ServoDetailsPopup.module.css'

function ServoDetailsPopup(props) {
    const {
        createActionState,
        servoDetailsPopUpObj,
        setServoDetailsPopUpObj,
        handleMinMax,
        showCloseBtn = true,
        handleSliderChange,
        handleSliderBtnClick,
        selectedAction,
    } = props
    const connectedDevice = sessionStorage.getItem('connectedDevice')
    // const createActionState = JSON.parse(
    //     sessionStorage.getItem('createActionState')
    // )
    const deviceVersion = sessionStorage.getItem('deviceVersion') || '0.0.0'
    const isZingVersion12 =
        ['1', '2', '3'].includes(
            (sessionStorage.getItem('deviceVersion') || '0.0.0')[0]
        ) && ['Humanoid'].includes(sessionStorage.getItem('connectedDevice'))

    const handleDialogModalClose = () => {
        setServoDetailsPopUpObj({
            isShowsServoDetailsPopUp: false,
            servoId: 0,
            actionNumber: 0,
        })
    }

    useEffect(() => {
        if (!servoDetailsPopUpObj.isShowsServoDetailsPopUp || !showCloseBtn) {
            return
        }
        const handleKeyDown = (e) => {
            if (e.key === 'Escape') {
                setServoDetailsPopUpObj({
                    isShowsServoDetailsPopUp: false,
                    servoId: 0,
                    actionNumber: 0,
                })
            }
        }
        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [
        servoDetailsPopUpObj.isShowsServoDetailsPopUp,
        showCloseBtn,
        setServoDetailsPopUpObj,
    ])

    const handleOverlayMouseDown = (e) => {
        if (showCloseBtn && e.target === e.currentTarget) {
            handleDialogModalClose()
        }
    }

    //calculate the servo details popup Time in milisecond
    const calculateTime = (actionNumber) => {
        let times = 0
        let allActions = createActionState.allActions

        if (actionNumber >= allActions.length) {
            return 0
        }
        for (let i = 0; i <= actionNumber; i++) {
            times += allActions[i].data['T'].value
        }
        return times
    }

    const digitalInputTypes = [
        'tact_switch',
        'touch_sensor',
        'dual_switch',
        'dip_switch',
        'metal_detector',
        'pir_sensor',
    ]

    const isDigitalInput = (servoId) => {
        const type =
            createActionState.allActions[servoDetailsPopUpObj.actionNumber]
                ?.data?.[servoId]?.type
        return digitalInputTypes.includes(type)
    }

    const getMinValue = (servoId) => {
        if (isDigitalInput(servoId)) {
            return 0
        }
        if (connectedDevice === 'Hexapod') {
            return handleMinMax(servoDetailsPopUpObj.servoId, 'MIN', 'HEXAPOD')
        } else if (isZingVersion12) {
            return handleMinMax(servoDetailsPopUpObj.servoId, 'MIN', 'ZING')
        } else return 0
    }

    const getMaxValue = (servoId) => {
        if (servoId === 'T') {
            return 5000
        }
        if (servoId === 'H') {
            return 180
        }
        if (isDigitalInput(servoId)) {
            return 1
        }
        if (connectedDevice === 'Hexapod') {
            return handleMinMax(servoDetailsPopUpObj.servoId, 'MAX', 'HEXAPOD')
        } else if (isZingVersion12) {
            return handleMinMax(servoDetailsPopUpObj.servoId, 'MAX', 'ZING')
        } else return 1000
    }

    return (
        <>
            {servoDetailsPopUpObj.isShowsServoDetailsPopUp && (
                <div
                    className={servoPopupStyle.servoPopupMain}
                    role="dialog"
                    aria-modal="true"
                    aria-label={`Servo Motor ${servoDetailsPopUpObj.servoId} details`}
                    onMouseDown={handleOverlayMouseDown}
                >
                    <div className={servoPopupStyle.servoPopupBox}>
                        {showCloseBtn && (
                            <button
                                type="button"
                                className={servoPopupStyle.closeBtn}
                                onClick={handleDialogModalClose}
                                aria-label="Close"
                            >
                                <img
                                    src={renderImage('clos')}
                                    alt=""
                                    draggable={false}
                                />
                            </button>
                        )}
                        <div className={servoPopupStyle.infoRow}>
                            <span className={servoPopupStyle.chip}>
                                Time (Millisecond)
                                <strong>
                                    {calculateTime(
                                        servoDetailsPopUpObj.actionNumber
                                    )}
                                </strong>
                            </span>
                            <span className={servoPopupStyle.chip}>
                                Motor No
                                <strong>{servoDetailsPopUpObj.servoId}</strong>
                            </span>
                        </div>
                        <div className={servoPopupStyle.servoPopupBody}>
                            <SliderBox
                                isDisabledAction={
                                    false
                                    // display !== 'block' || isEnableReadServo
                                }
                                // isDisabledAction={true}
                                key={servoDetailsPopUpObj.servoId}
                                id={servoDetailsPopUpObj.servoId}
                                btnText={`Servo Motor ${servoDetailsPopUpObj.servoId}`}
                                sliderText="Value"
                                value={
                                    createActionState.allActions[
                                        servoDetailsPopUpObj.actionNumber
                                    ].data[servoDetailsPopUpObj.servoId].value
                                }
                                min={getMinValue(servoDetailsPopUpObj.servoId)}
                                max={getMaxValue(servoDetailsPopUpObj.servoId)}
                                handleSliderChange={handleSliderChange}
                                // handleClick={(servoId) =>
                                //     handleSliderBtnClick(
                                //         servoId,
                                //         servoDetailsPopUpObj.actionNumber
                                //     )
                                // }
                                // isEnabled={
                                //     createActionState.allActions[
                                //         servoDetailsPopUpObj.actionNumber
                                //     ].data[servoDetailsPopUpObj.servoId]
                                //         .isEnabled
                                // }
                                handleClick={() => {}}
                                isEnabled={
                                    servoDetailsPopUpObj.actionNumber ===
                                    selectedAction
                                }
                                type="single"
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}
export default ServoDetailsPopup
